"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
var _wrapperUtils = require("./utils/wrapperUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RaqButton = function RaqButton(_ref) {
  var requestAQuoteUrl = _ref.requestAQuoteUrl,
    ghostRaqButton = _ref.ghostRaqButton,
    serviceProviderId = _ref.serviceProviderId,
    customClass = _ref.customClass,
    LinkWrapperComponent = _ref.LinkWrapperComponent,
    dataTrackingPropsForRaqBtn = _ref.dataTrackingPropsForRaqBtn;
  var WrappedButton = (0, _wrapperUtils.createWrappedComponent)(_angieslistReactComponents.Button, LinkWrapperComponent);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WrappedButton, (0, _extends2["default"])({
    id: "featured-sp-card-request-a-quote-button-".concat(serviceProviderId),
    href: requestAQuoteUrl,
    bsSize: "xsmall",
    bsStyle: "warning",
    ghost: ghostRaqButton,
    block: true,
    className: customClass,
    style: {
      top: 0,
      boxShadow: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, dataTrackingPropsForRaqBtn), 'Request a Quote'));
};
RaqButton.propTypes = {
  serviceProviderId: _propTypes["default"].number.isRequired,
  requestAQuoteUrl: _propTypes["default"].string.isRequired,
  ghostRaqButton: _propTypes["default"].bool,
  customClass: _propTypes["default"].string,
  LinkWrapperComponent: _propTypes["default"].element,
  // eslint-disable-next-line react/forbid-prop-types
  dataTrackingPropsForRaqBtn: _propTypes["default"].object
};
RaqButton.defaultProps = {
  ghostRaqButton: false,
  customClass: 'request-a-quote-button',
  LinkWrapperComponent: null,
  dataTrackingPropsForRaqBtn: {}
};
var _default = exports["default"] = RaqButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/raqButton.js
// module id = 2870
// module chunks = 25